var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { communityFeatures } = options; 
__p+='\n\n<div class="subsection" style="margin-bottom:20px;">\n  <h2 class="header-subsection">\n  </h2>\n  <div class="features js-features-load-more">\n    ';
 communityFeatures.forEach((feature) => { 
__p+='\n    <div class="clearfix">\n      <h4 class="title-subsection-sm">\n        ';
 if(feature.category == "Health And Fitness") { 
__p+='\n          Amenities\n        ';
 } else if(feature.category == "Community Services") { 
__p+='\n          Services\n        ';
 } else if(feature.category == "Utilities") { 
__p+='\n          Utility\n        ';
 } else { 
__p+='\n          '+
((__t=( feature.category ))==null?'':__t)+
'\n        ';
 } 
__p+='\n      </h4>\n      <ul class="row list-default list">\n        ';
 feature.text && feature.text.forEach((item) => { 
__p+='\n        <li class="col-qv-sm-4">\n          <span>'+
((__t=( item ))==null?'':__t)+
'</span>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 }) 
__p+='\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-subsec-community-features.jst.ejs